import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BestSellers } from './components/BestSellers';
import { FlavorMenu } from './components/FlavorMenu';
import { Products } from './components/Products';
import { CultureSection } from './components/CultureSection';
import { Subscriptions } from './components/Subscriptions';
import { Preorder } from './components/Preorder';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { PaymentCancelled } from './pages/PaymentCancelled';
import { Toaster } from './components/ui/sonner';

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <BestSellers />
    <FlavorMenu />
    <Products />
    <CultureSection />
    <Subscriptions />
    <Preorder />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancelled" element={<PaymentCancelled />} />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;